import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/core';
import { Tree } from './components';

const useStyles = makeStyles(
  createStyles({
    emptyPaper: {
      minHeight: 2,
      display: 'flex',
      alignItems: 'center',
    },
  })
);

const ProductCatalogList: React.FC = () => {
  const { url } = useParams();

  return (
    <>
      <ul className='kt-menu__subnav' style={{ paddingLeft: 17, listStyle: 'none' }}>
        <Tree categories={[]} activeId={url} />
      </ul>
    </>
  );
};

export default ProductCatalogList;
